import { useCallback, useMemo } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import { IBudgetPeriod } from 'src/types/BudgetPeriod';
import axiosInstance from 'src/utils/axios';

export interface BudgetPeriodResponse {
  glPeriodId: number;
  amount: number;
  isClosed: number | null;
}

const useMultiPeriodAllocationGetApi = (
  poId: string,
  initialMultiBudgetPeriods: IBudgetPeriod[]
) => {
  const call = useCallback(async () => {
    try {
      const res = await axiosInstance.get<{
        periodAllocations: BudgetPeriodResponse[];
        canEditPo: boolean;
      }>(api.getMultiPeriodAllocation(poId));
      return res.data;
    } catch (error) {
      throw new Error(error);
    }
  }, [poId]);

  const { value, execute, isLoading } = useAsync(call, true);
  const multiBudgetPeriods = useMemo(
    () => (value?.periodAllocations.length ? value?.periodAllocations : initialMultiBudgetPeriods),
    [initialMultiBudgetPeriods, value?.periodAllocations]
  );
  return {
    multiBudgetPeriods,
    canEditPeriods: value?.canEditPo,
    getMultiBudgetPeriods: execute,
    isBudgetPeriodLoading: isLoading,
  };
};

export default useMultiPeriodAllocationGetApi;
